import { Plus, Minus, Maximize } from "lucide-react"
import { Button } from "@/components/ui/button"

interface MapZoomControlsProps {
  onZoomIn: () => void
  onZoomOut: () => void
  onResetView: () => void
}

export default function MapZoomControls({
  onZoomIn,
  onZoomOut,
  onResetView,
}: MapZoomControlsProps): React.JSX.Element {
  return (
    <div
      role="group"
      aria-label="Map zoom controls"
      className="absolute bottom-10 right-4 z-10 flex flex-col overflow-hidden rounded-xl border border-border/60 bg-background/80 shadow-xl ring-1 ring-black/5 backdrop-blur-md"
    >
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-6 rounded-none hover:bg-muted/40"
        onClick={onZoomIn}
        aria-label="Zoom in"
        title="Zoom in"
      >
        <Plus className="size-4" aria-hidden="true" />
      </Button>

      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-6 rounded-none border-t border-border/60 hover:bg-muted/40"
        onClick={onZoomOut}
        aria-label="Zoom out"
        title="Zoom out"
      >
        <Minus className="size-4" aria-hidden="true" />
      </Button>

      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-6 rounded-none border-t border-border/60 hover:bg-muted/40"
        onClick={onResetView}
        aria-label="Reset to default view"
        title="Reset view (100%)"
      >
        <Maximize className="size-4" aria-hidden="true" />
      </Button>
    </div>
  )
}
